import { RouterProvider, createMemoryRouter } from 'react-router-dom';
import { RouteBoundary } from './ErrorBoundaries';
import FallbackSpinner from './ErrorBoundaries/FallbackSpinner/FallbackSpinner';
import { useTribalContext } from './context/tribal';
import { PATHS, transformPaths } from './hooks/useAppNavigate';
import AnimatedPageContainer from './modules/layouts/AnimatedPageContainer';
import { Compare, Expired, Terms, Welcome } from './modules/pages';
import Single from './modules/pages/Single';

const ROUTES = [
  {
    path: PATHS.all,
    errorElement: <RouteBoundary />,
  },
  {
    path: PATHS.welcome,
    element: <Welcome />,
    errorElement: <RouteBoundary />,
  },
  {
    path: PATHS.compare,
    element: <Compare />,
    errorElement: <RouteBoundary />,
  },
  {
    path: PATHS.msc,
    element: <Single />,
    errorElement: <RouteBoundary />,
  },
  {
    path: PATHS.orderNumber,
    element: <Single />,
    errorElement: <RouteBoundary />,
  },
  {
    path: PATHS.vin,
    element: <Single />,
    errorElement: <RouteBoundary />,
  },
  {
    path: PATHS.expired,
    element: <Expired />,
    errorElement: <RouteBoundary />,
  },
  {
    path: PATHS.terms,
    element: <Terms />,
    errorElement: <RouteBoundary />,
  },
];

const AppRouteProvider = () => {
  const { appConfig } = useTribalContext();
  const router = createMemoryRouter(
    [
      {
        element: <AnimatedPageContainer />,
        children: transformPaths(ROUTES),
      },
    ],
    {
      initialEntries: [`/${appConfig.pdbId}`],
    }
  );

  return (
    <RouterProvider router={router} fallbackElement={<FallbackSpinner />} />
  );
};

export default AppRouteProvider;
